import { fetchApi } from '@/config/axiosSetting';
import {
  GetAdjusterOtherDamagedImagesQueryParamsType,
  GetAdjusterOtherDamagedImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getAdjusterOtherDamagedImages/getAdjusterOtherDamagedImagesQuery.type';

export const getAdjusterOtherDamagedImagesFunction = (
  params: GetAdjusterOtherDamagedImagesQueryParamsType,
): Promise<GetAdjusterOtherDamagedImagesQueryResponseType> => {
  return fetchApi.get(
    `property/reports/${params.id}/accident_users/damaged/adjuster/damaged/`,
    { params },
  );
};
